<template>
  <keep-alive>
    <transition-group
      :name="transition"
      :duration="200"
    >
      <component
        :is="modal"
        v-for="(modal, index) in modalsNames"
        :key="modal"
        :params="modals && modals[index] && modals[index].params"
      />
    </transition-group>
  </keep-alive>
</template>

<script>
import { mapGetters } from 'vuex'

import EnterPhone from '@/components/signInV2/EnterPhone'
import EnterSms from '@/components/signInV2/EnterSms'
import Info from '@/components/signInV2/Info'

import { openModalScroll, closeModalScroll } from '@/services/modal'

export default {
  components: {
    EnterPhone,
    EnterSms,
    Info,
  },
  data () {
    return {
      show: true,
    }
  },
  computed: {
    ...mapGetters({
      modals: 'modals/modals',
      modalsNames: 'modals/modalsNames',
      activeModal: 'modals/activeModal',
      activeModalName: 'modals/activeModalName',
    }),
    transition () {
      return this.$isSmartphone ? 'fade-top' : 'fade'
    },
  },
  watch: {
    // $route () {
    //   this.processBlackNavbar()
    // },
    activeModal (val) {
      if (val) {
        openModalScroll()
      } else {
        closeModalScroll()
      }
    },
  },
}
</script>
